import { render, staticRenderFns } from "./addComponent.vue?vue&type=template&id=4aeed310&scoped=true&"
import script from "./addComponent.vue?vue&type=script&lang=js&"
export * from "./addComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeed310",
  null
  
)

export default component.exports